import React from 'react';

const MarketSelector = ({ selectedMarket, onMarketChange }) => {
  const markets = [
    { id: 'jita', name: 'Jita' },
    { id: 'ualx', name: 'Ualx ' },
    { id: 'e3oi', name: 'E3oi' },
    { id: 'pzmzv', name: 'P-zmzv' },
    { id: 'amarr', name: 'Amarr' },
    { id: 'dodi', name: 'Dodixie' },
    { id: 'hek', name: 'Hek' },
    { id: 'rens', name: 'Rens' },
  ];

  return (
    <div className="market-selector">
      <select
        value={selectedMarket}
        onChange={(e) => onMarketChange(e.target.value)}
        className="w-auto px-4 py-3 bg-neutral-900 border border-gray-600 rounded-lg 
                 text-gray-100 placeholder-gray-400 focus:ring-3 focus:ringww-orange-700
                  font-mono hover:border-orange-400 "
      >
        <option value="" disabled>Select a market</option>
        {markets.map(market => (
          <option key={market.id} value={market.id}>
            {market.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MarketSelector;